/**
*   Log object class. EventEmitter.
*   has methods log, test, info, warn, debug, error and success
*/
export class Log
{

  constructor()
  {
    this._format = 'dd/mm/yyyy hh:ii:ss'
    this._pretty = false
    this._on = {
      debug: false,
      log: true,
      warn: true,
      test: true,
      success: true,
      err: true,
      info: true
    }
    this._ee = null
  }

  emitter(e) {
    if (typeof e !== 'undefined')
      this._ee = e
    return this._ee
  }

  setFormat(next) {
    this._format = next
  }

  setPretty(next) {
    this._pretty = !!next
  }

  setOuts(outs)
  {
    if (outs)
    this._on = {
      ...this._on,
      ...outs
    }
  }

  m(m)
  {
    let ret = {
      l: this,
      emitter: (e) => this.emitter(e),
      debug: (...a)=> this.debug(m,...a),
      log: (...a)=> this.log(m,...a),
      info: (...a)=> this.info(m,...a),
      test: (...a)=> this.test(m,...a),
      warn: (...a)=> this.warn(m,...a),
      err: (...a)=> this.err(m,...a),
      success: (...a)=> this.success(m,...a) 
    }
    return ret
  }


  date()
  {
    let dt = new Date()
    let dd = dt.getDate().toString()
    let mm = (dt.getMonth()+1).toString()
    let yy = dt.getFullYear().toString()
    let hh = dt.getHours().toString()
    let ii = dt.getMinutes().toString()
    let ss = dt.getSeconds().toString()
    dd = dd.length > 1 ? dd : '0'+dd
    mm = mm.length > 1 ? mm : '0'+mm
    hh = hh.length > 1 ? hh : '0'+hh
    ii = ii.length > 1 ? ii : '0'+ii
    ss = ss.length > 1 ? ss : '0'+ss
    let str = this._format.trim()
    str=str.replace(/dd/g,dd)
    str=str.replace(/mm/g,mm)
    str=str.replace(/yyyy/g,yy)
    str=str.replace(/hh/g,hh)
    str=str.replace(/ii/g,ii)
    str=str.replace(/ss/g,ss)
    return str
  }

  vars(lvl, defKey, key, msg, data = [])
  {
    const ret = {
      lvl,
      key: key || defKey,
      msg: msg || '',
    }
    if (Array.isArray(data) && data.length) {
      const last = data[data.length - 1]
      if (last && last.pretty === true) {
        data.pop()
        ret.pretty = true
      }
      ret.data = data
    }
    if (this._ee) this._ee.emit(ret)
    return ret
  }

  /**
  *   final method checking pretty and printing data
  */
  _clog(vars)
  {
    const msg = this._msg(vars)
    const data = vars.data || []
    if (data.length && (this._pretty || vars.pretty)) {
      console.log(msg, JSON.stringify(data))
    } else {
      console.log(msg, ...data)
    }
  }

  /**
  *   message formating
  */
  _msg(vars) {
    return `[${vars.lvl.toUpperCase()}] [${vars.key}] ${vars.msg}`
    // return `${this.date()} [${vars.lvl.toUpperCase()}] [${vars.key}] ${vars.msg}`
  }

  /**
  *   debug method
  */
  debug(key, msg, ...data) {
    const vars = this.vars('dbg', '..', key, msg, data)
    if (!this._on.debug) return vars
    this._clog(vars)
    return vars
  }

  /**
  *   log method
  */
  log(key, msg, ...data) {
    const vars = this.vars('log', '..', key, msg, data)
    if (!this._on.log) return vars
    this._clog(vars)
    return vars
  }

  /**
  *   info method
  */
  info(key, msg, ...data)
  {
    const vars = this.vars('info', '..', key, msg, data)
    if (!this._on.info) return vars
    this._clog(vars)
    return vars
  }


  /**
  *   test method
  */
  test(key, msg, ...data)
  {
    const vars = this.vars('test', '??', key, msg, data)
    if (!this._on.test) return vars
    this._clog(vars)
    return vars
  }

  /**
  *   warn method
  */
  warn(key, msg, ...data)
  {
    const vars = this.vars('warn', '!?', key, msg, data)
    if (!this._on.warn) return vars
    this._clog(vars)
    return vars
  }

  /**
  *   error method
  */
  err(key, msg, ...data)
  {
    const vars = this.vars('error', '!!', key, msg, data)
    if (!this._on.err) return vars
    this._clog(vars)
    return vars
  }

  /**
  *   success method
  */
  success(key, msg, ...data)
  {
    const vars = this.vars('success', 'OK', key, msg, data)
    if (!this._on.success) return vars
    this._clog(vars)
    return vars
  }

}

export const LOG = new Log()
